import React from 'react'
import Header from '../components/Header/Header'
import Navbar from '../components/Navbar/Navbar'

const Mid_Career_Scientist_Award = () => {
    return (
        <div>
            <Header/>
            <Navbar/>
            <div className="px-4">
                  <div className="max-w-7xl mx-auto bg-white p-6 ">
                    {/* Header Section */}
                    <header className="flex justify-between items-center mb-2 pb-6">
                      <h1 className="text-3xl md:text-4xl text-blue-800 ">I.I.S. Awards</h1>
                    
                    </header>
            
                    {/* Content Section */}
                    <section>
                      <h2 className="text-2xl md:text-3xl text-gray-600 mb-4 "> IIS Mid-Career Scientist Award</h2>
                      <p className="text-md md:text-lg text-gray-600 mb-4">
                      The IIS Mid-Career Scientist Award recognizes exceptional contributions made by a scientist between the ages of 35 and 50 in the fields of basic and applied Immunology research and education, with all work conducted in India. The award aims to honor individuals who have demonstrated significant advancements in their research and have made a lasting impact on the scientific community. </p>
            
                      <p className="text-md md:text-lg text-gray-600 mb-4">
                      The award carries a Certificate, Medal, and Cash Prize of Rs. 15,000/-.      </p>
                    <p className="text-md md:text-lg text-gray-600 mb-4">To apply, nominations (including self-nominations) should be submitted using the 'Application/Nomination Form for IIS-Awards' by 31st August, 2024. Nominations must be emailed directly to indianimmunologysociety2024@gmail.com with a CC to kaustuvnayak@gmail.com, using the subject line "IIS Mid-Career Scientist Award."  

</p>
                      <p className="text-md md:text-lg text-gray-600 mb-4">
                      For further details, including eligibility and application procedures, please visit the IIS website at  <a href="https://www.indianimmunologysociety.org/"className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">click here</a>.
                      </p>
                     
                    </section>
                  </div>
                  <div className="bg-gray-100 mt-6 py-4">
          <div className="max-w-7xl mx-auto px-4 text-center">
            
            <p className="text-base mb-6">
              Nomination Form:
              <a
                href="/nomination_form.pdf"
                download
                className="text-[#4f46e5] underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                click here
              </a>
              .
            </p>
            <p className="text-base mb-6">
              Guideline:
              <a
                href="/guidelines.pdf"
                download
                className="text-[#4f46e5] underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                click here
              </a>
              .
            </p>

          </div>
        </div>
                </div>
            
        </div>
        
    )
}

export default Mid_Career_Scientist_Award
